import classes from "./SeatsRadioButton.module.scss";

const SeatsRadioButton = ({ text, defaultChecked, onChangeSeats }) => {
  return (
    <div className={classes.SeatsRadioButton}>
      <input
        defaultChecked={defaultChecked}
        id={text}
        type="radio"
        name="bookingSeats"
        onChange={() => onChangeSeats(text)}
      />
      <label htmlFor={text}>{text}</label>
    </div>
  );
};

export default SeatsRadioButton;
